import { APICallV2Post } from './APICall';

export class CopyAPICall extends APICallV2Post {
    _method = 'file/copy';
}
